const r = "_drawer_7w8m4_1", t = "_drawerRight_7w8m4_11", e = "_drawerLeft_7w8m4_17", w = "_drawerBottom_7w8m4_23", o = "_drawerTop_7w8m4_29", _ = "_content_7w8m4_49", a = "_handle_7w8m4_59", d = {
  drawer: r,
  drawerRight: t,
  drawerLeft: e,
  drawerBottom: w,
  drawerTop: o,
  content: _,
  handle: a
};
export {
  _ as content,
  d as default,
  r as drawer,
  w as drawerBottom,
  e as drawerLeft,
  t as drawerRight,
  o as drawerTop,
  a as handle
};
//# sourceMappingURL=index.es903.js.map
